import { styled } from '@mui/material/styles';
import { ChatSize } from '../../../enums/ChatAgentCreationStep';
import { getDimension } from '../../../helpers/agentHelper';

const StyledChatConfigPreview = styled('div')`
  position: relative;
  width: ${getDimension(ChatSize.SMALL).width};
  height: calc(${getDimension(ChatSize.SMALL).height} + 5rem);
`;

export default StyledChatConfigPreview;
